import script from "./MenuPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuPage.vue?vue&type=script&setup=true&lang=ts"

import "./MenuPage.vue?vue&type=style&index=0&id=52552609&lang=scss"

const __exports__ = script;

export default __exports__